<template>
    <div class="sign_exam">
        <div class="sign_level">
            <h4><b>*</b>难易程度：</h4>
            <div class="sign_radio">
                <el-radio v-model="radio" label="1" >简单</el-radio>
                <el-radio v-model="radio" label="2" >一般</el-radio>
                <el-radio v-model="radio" label="3" >较难</el-radio>
                <el-radio v-model="radio" label="4" >困难</el-radio>
            </div>
        </div>    
        <div class="sign_title">
            <h4><b>*</b>题目：</h4>
            <el-input v-model="input" placeholder="请输入试题题目"></el-input>
        </div>   
        <div class="sign_answer">
            <h4 class="lf"><b>*</b>答案选项：</h4>
            <h5 class="rf">正确答案</h5>
            <div class="clear"></div>
            <div class="sing_wrap">
                <div class="sign_xx"  v-for="(item,index) in list_anwer" :key='index'>
                    <el-tag
                        type=""
                        effect="dark" class="lf tag_sign">
                        {{item.id}}
                    </el-tag>
                    <el-input v-model="item.name" placeholder="请输入试题题目" class="lf"></el-input>
                    <el-radio v-model="radioSign" class="radioSign" :data-id="index" :label="index"></el-radio>
                    <img src="../../../static/img/icon_err.png" class="err_img" @click="demoList(index)">
                </div>
                <div class="clear"></div>
                <div class="add_xx" @click='add_answer()'>
                    <i class="el-icon-plus"></i><span class="add_answer">新增选项</span>
                </div>
            </div>
        </div>  
        <div class="clear"></div>
        <div class="sign_know">
            <span>知识点：</span>
            <button v-show="showbtn" @click="showKonw">
                <i class="el-icon-plus"></i><span class="add_answer">知识点</span>
            </button>
            <el-input v-model="konws" v-show="konwshow"></el-input>
        </div>
        <div class="sign_analysis">
            <span>答案解析：</span>
            <el-input
                type="textarea"
                :rows="2"
                resize='none'
                placeholder="请输入内容"
                v-model="textarea">
            </el-input>
        </div>
        <div class="btn_up">
                <el-button type="primary" @click="upExam">提交</el-button>
        </div>
    </div>
</template>
<script>
    export default{
        name:'sign',
        data () {
            return {
                radio: '1',
                imageUrl: '',
                konwshow:false,
                konws:'',
                showbtn:true,
                id:this.$route.query.id,
                qid:this.$route.query.q_id,
                url:this.HOME,
                radioSign:'',
                list_anwer:[],
                input:'',
                textarea:'',
            };
        },
         methods: {
            add_answer() {
                let letterArr = [];
                for (var i = 65; i < 91; i++) {
                   letterArr.push(String.fromCharCode(i))
                }
                var len =this.list_anwer.length
                var code ={
                    id:letterArr[len],
                    name:''
                }
                this.list_anwer.push(code)
            },
            demoList(i){
                this.list_anwer.splice(i,1)
                let letterArr = [];
                for (var i = 65; i < 91; i++) {
                   letterArr.push(String.fromCharCode(i))
                }
                for(let n in this.list_anwer){
                    this.list_anwer[n].id=letterArr[n]
                }
                console.log(this.list_answer)
            },
            showKonw(){
                this.showbtn=false
                this.konwshow=true
            },
            upExam(){
                var answerList=[]
                for (var i = 0; i < this.list_anwer.length;i++) {
                    if(this.list_anwer[i].name===''){
                        this.alertView.failView('请填写答案')
                        return false
                    }
                    var res = this.list_anwer[i].name;
                    answerList.push(res);
                }
                if(this.id){
                    var data={
                        id:this.id,
                        level:this.radio,
                        questions:this.input,
                        type:1,
                        parsing_answer:this.textarea,
                        knowledge:this.konws,
                        service:'Question.QsnUpdate',
                        correct_answer:this.radioSign,
                        answer:JSON.stringify(answerList),
                        userid:localStorage.getItem('userid')
                    }
                }
                else{
                var data={
                    e_id:this.qid,
                    level:this.radio,
                    questions:this.input,
                    type:1,
                    parsing_answer:this.textarea,
                    knowledge:this.konws,
                    service:'Question.QsnAdd',
                    correct_answer:this.radioSign,
                    answer:JSON.stringify(answerList),
                        userid:localStorage.getItem('userid')
                    }
                }    
                if(this.radioSign===''){
                    this.alertView.failView('请勾选正确答案')
                    return false
                }
                this.$axios.post(this.url,this.$qs.stringify(data))
                .then(res=>{
                    if(res.data.data.code==0){
                        this.alertView.successView('数据提交成功')
                        this.$router.push({ path:'/detail/',query: {id:this.qid}})
                    }
                    else{
                        this.alertView.failView(res.data.data.msg)
                    }
                })
                    .catch(function (error) { // 请求失败处理
                        this.alertView.failView(res.data.data.msg)
                });  

            }
        },
        mounted(){
            if(this.id){
                var List={
                    service:'Question.QsnEdit',
                    qid:this.id
                }
                var data =[];
                let letterArr = [];
                for (var i = 65; i < 91; i++) {
                   letterArr.push(String.fromCharCode(i))
                }
            {
               this.$axios.post(this.HOME,this.$qs.stringify(List))
                    .then(res=>{
                    this.radio = res.data.data.level;
                    this.input =res.data.data.questions;
                    for (let n in res.data.data.answer){
                        data.push({id:letterArr[n],name:res.data.data.answer[n]})
                    }
                    this.list_anwer = data
                    var arr =JSON.parse(res.data.data.correct_answer)
                    this.radioSign=arr
                    if(res.data.data.knowledge){
                        this.showbtn=false
                        this.konwshow=true
                        this.konws=res.data.data.knowledge
                    }
                    this.textarea=res.data.data.parsing_answer
                }) 
            }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/examView/sign.vue